import { useRequestLotteries } from '~/repositories'

/** Fetches the prize list for regular lotteries. `params` is a pre-serialised query string. */
export const getPrizes = (params: any) => {
	return useRequestLotteries('get', `/prizes?${params}`)
}

/** Fetches the prize breakdown detail for a regular lottery draw. `params` is a pre-serialised query string. */
export const getPrizeDetail = (params: any) => {
	return useRequestLotteries('get', `/prizes/detail?${params}`)
}

/** Fetches the results list for regular lotteries. `params` is passed as query params object. */
export const getGeneralLottery = (params: any) => {
	return useRequestLotteries('get', `/general_lottery`, { params })
}

/** Fetches the detailed result for a single regular lottery draw. `params` is a pre-serialised query string. */
export const getGeneralLotteryDetail = (params: any) => {
	return useRequestLotteries('get', `/general_lottery/detail?${params}`)
}

export default {
	getPrizes,
	getPrizeDetail,
	getGeneralLottery,
	getGeneralLotteryDetail,
}
